import axiosInstance from "./config/axios";

/**
 * Get active coupon banner for display
 * @param {string} page - Optional page slug to filter
 * @returns {Promise} - Response with active banner data
 */
export const getActiveBanner = async (page = null) => {
    const params = page ? { page } : {};
    const response = await axiosInstance.get("/api/coupon-banners/active", {
        params,
    });
    return response.data;
};

/**
 * Claim a coupon from a banner (lead capture)
 * @param {number} bannerId - The banner ID
 * @param {string} email - User's email address
 * @returns {Promise} - Response with unique coupon code
 */
export const claimCoupon = async (bannerId, email) => {
    const response = await axiosInstance.post(
        `/api/coupon-banners/${bannerId}/claim`,
        { email }
    );
    return response.data;
};

export default {
    getActiveBanner,
    claimCoupon,
};
